export default __webpack_public_path__ + "static/revolutionizing-civic-recruitment-with-registration-management-system-c1f4e9b89ebe2a92860f07096176c11f.png";